import extendNode from '../extendNode.mjs'
import useCatRootModuleNode from '../_CAT_ROOT_MODULE/useCatRootModuleNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootUm.jsx'
import meta from './metaCatRootUm.mjs'

export default () => {
    const CatRootModuleNode = useCatRootModuleNode()

    return extendNode(CatRootModuleNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            return /^(UI)$/.test(type)
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'UI'},
            ]
        },
    })
}
